import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  templateUrl: 'four04-page.component.html',
  styleUrls: ['four04-page.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Four04PageComponent {}
